export { default as Paper } from './paper';
export type { PaperAppearance } from './styled';
export { PaperContent, bpMobileWebWidth, SmallPaddingPaperContent } from './styled';
